export default __webpack_public_path__ + "static/media/icon_1.518b5340.png";